import { render, staticRenderFns } from "./my_social_networks.vue?vue&type=template&id=2d95e5a0"
import script from "./my_social_networks.vue?vue&type=script&lang=js"
export * from "./my_social_networks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports